import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Header from "../components/Header";
import Footer from "../components/Footer";
import { removeFromCart, updateCartQuantity } from '../shopify/cartActions';

const Cart = (props) => {
    const dispatch = useDispatch();
    const { lines, checkoutUrl, loading, error } = useSelector((state) => state.cart);

    console.log(checkoutUrl)

    const subtotal = lines.reduce((sum, item) => sum + parseFloat(item.price) * item.quantity, 0);
    const total = subtotal;
    const currency = lines[0]?.currency || 'ZMW';
    const totalItems = lines.reduce((sum, item) => sum + item.quantity, 0);

    return (
        <>
            <Header />

            <div id="content-header">
                <div className="container">
                    <div className="d-flex align-items-center" style={{ gap: '16px' }}>
                        <h1 className="text-uppercase">CARTS</h1>
                        {lines.length > 0 && (
                            <span style={{ fontSize: '0.85rem', letterSpacing: '2px', color: '#555', marginTop: '6px' }}>
                                [ {totalItems} {totalItems === 1 ? 'ITEM' : 'ITEMS'} ]
                            </span>
                        )}
                    </div>
                </div>
            </div>

            <div className="container mt-5 mb-5">
                {error && <p className="text-danger mb-3">{error}</p>}
                {loading && <p className="text-muted mb-3">Updating cart...</p>}

                {lines.length === 0 && !loading ? (
                    <div className="text-center mt-5 mb-5">
                        <p style={{ fontSize: '1.1rem', color: '#888' }}>Your cart is empty.</p>
                        <button
                            className="btn btn-primary btn-cart-1 mt-3"
                            style={{ letterSpacing: '2px', padding: '12px 32px' }}
                            onClick={() => props.history.push('/')}
                        >
                            GO TO HOMEPAGE
                        </button>
                    </div>
                ) : (
                    <div className="row">

                        {/* LEFT — Cart Items */}
                        <div className="col-12 col-md-7" id="product">
                            {lines.map((item, index) => (
                                <div key={item.lineId}>
                                    <div className="d-flex" style={{ padding: '24px 0', gap: '20px' }}>

                                        {/* Product Image */}
                                        <div style={{ flexShrink: 0 }}>
                                            <img
                                                src={item.image || 'assets/images/sample-1.jpg'}
                                                alt={item.title}
                                                style={{ width: '170px', height: '200px', objectFit: 'cover' }}
                                            />
                                        </div>

                                        {/* Product Info */}
                                        <div className="d-flex flex-column justify-content-between" style={{ flex: 1 }}>
                                            <div>
                                                <div className="d-flex justify-content-between align-items-start">
                                                    <h4 style={{ fontWeight: 700, fontSize: '1.2rem', letterSpacing: '0.5px', margin: 0 }}>
                                                        {item.title}
                                                    </h4>
                                                    <p style={{ fontWeight: 400, fontSize: '1rem' }}>
                                                        {currency}{parseFloat(item.price).toFixed(2)}
                                                    </p>
                                                </div>

                                                {/* Variant options split by / */}
                                                <div style={{ marginTop: '12px' }}>
                                                    {item.variantTitle && item.variantTitle !== 'Default Title' &&
                                                        item.variantTitle.split('/').map((v, i) => (
                                                            <p key={i} style={{ margin: 0, fontSize: '0.85rem', color: '#333', letterSpacing: '1px', textTransform: 'uppercase' }}>
                                                                {v.trim()}
                                                            </p>
                                                        ))
                                                    }
                                                </div>
                                            </div>

                                            {/* Quantity + Delete */}
                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                <div className="d-flex align-items-center" style={{ gap: '16px', fontSize: '1rem' }}>
                                                    <button
                                                        onClick={() => {
                                                            if (item.quantity > 1) {
                                                                dispatch(updateCartQuantity(item.lineId, item.quantity - 1));
                                                            }
                                                        }}
                                                        style={{ background: 'none', border: 'none', fontSize: '1.2rem', cursor: 'pointer', padding: '0 4px', color: item.quantity <= 1 ? '#ccc' : '#000' }}
                                                        disabled={item.quantity <= 1}
                                                    >
                                                        -
                                                    </button>
                                                    <span style={{ fontWeight: 500, minWidth: '20px', textAlign: 'center' }}>
                                                        {item.quantity}
                                                    </span>
                                                    <button
                                                        onClick={() => dispatch(updateCartQuantity(item.lineId, item.quantity + 1))}
                                                        style={{ background: 'none', border: 'none', fontSize: '1.2rem', cursor: 'pointer', padding: '0 4px' }}
                                                    >
                                                        +
                                                    </button>
                                                </div>

                                                {/* Trash icon */}
                                                <button
                                                    onClick={() => dispatch(removeFromCart(item.lineId))}
                                                    style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#c0392b', padding: 0 }}
                                                    title="Remove item"
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
                                                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                                                        <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    {index < lines.length - 1 && <hr style={{ margin: 0 }} />}
                                </div>
                            ))}
                        </div>

                        <div className="col-12 col-md-4 offset-md-1 mt-4 mt-md-0">
                            <div style={{ background: '#F8F9FA', padding: '28px 24px' }} id="cart">
                                <h6>
                                    ORDER SUMMARY
                                </h6>

                                <div className="d-flex justify-content-between mb-2">
                                    <p style={{ fontSize: '0.85rem', letterSpacing: '1px', textTransform: 'uppercase', color: '#555' }}>Subtotal</p>
                                    <p style={{ fontSize: '0.85rem' }}>{currency}{subtotal.toFixed(2)}</p>
                                </div>

                                <hr style={{ borderColor: '#ddd' }} />

                                <div className="d-flex justify-content-between mt-3 mb-4">
                                    <p style={{ fontWeight: 700, letterSpacing: '1px', textTransform: 'uppercase', fontSize: 14 }}>Total</p>
                                    <p style={{ fontWeight: 700, fontSize: 14 }}>{currency}{total.toFixed(2)}</p>
                                </div>

                                <a href={checkoutUrl} className="btn btn-primary btn-cart-1 btn-block" target="_blank" rel="noopener noreferrer">CHECKOUT</a>
                        </div>
                    </div>

                    </div>
                    )}
            </div>

            <Footer />
        </>
    );
};

export default Cart;
